export default "__VITE_ASSET__52615281__"